// Casca dos charts do Dashboard — rule do repo: TODO chart tem os
// 3 estados (skeleton/empty/error) além do sucesso.
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

interface DashboardChartCardProps
  extends React.PropsWithChildren {
  title: string
  // Prefixo dos data-testid (ex.: "dashboard-series").
  testId: string
  isLoading: boolean
  hasError: boolean
  isEmpty: boolean
  // Mensagem de vazio específica (default: emptyState genérico).
  emptyMessage?: string
  onRetry: () => void
}

export const DashboardChartCard = ({
  title,
  testId,
  isLoading,
  hasError,
  isEmpty,
  emptyMessage,
  onRetry,
  children,
}: DashboardChartCardProps) => {
  const { t } = useTranslation()
  const dashboardPrefix =
    "pages.notificationCenter.dashboardPage"

  return (
    <Card className="rounded-t-none border-t-4 border-t-primary">
      <CardHeader>
        <CardTitle className="text-base font-semibold md:text-lg">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div
            data-testid={`${testId}-skeleton`}
            className="space-y-2"
          >
            <Skeleton className="h-6 w-2/3" />
            <Skeleton className="h-40 w-full" />
          </div>
        ) : hasError ? (
          <div className="flex flex-col items-center gap-3 rounded-md border border-red-200 bg-red-50 p-6">
            <p className="text-center text-sm text-red-700">
              {t(`${dashboardPrefix}.loadError`)}
            </p>
            <Button
              type="button"
              variant="outline"
              onClick={onRetry}
            >
              {t(`${dashboardPrefix}.retry`)}
            </Button>
          </div>
        ) : isEmpty ? (
          <p
            data-testid={`${testId}-empty`}
            className="rounded-md border p-8 text-center text-sm text-muted-foreground"
          >
            {emptyMessage ??
              t(`${dashboardPrefix}.emptyState`)}
          </p>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  )
}
